import { render } from "./detail.vue?vue&type=template&id=25d14470&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=25d14470&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d14470"],['__file',"resources/js/pages/notes/detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25d14470"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25d14470', __exports__)) {
    console.log('reload')
    api.reload('25d14470', __exports__)
  }
  
  module.hot.accept("./detail.vue?vue&type=template&id=25d14470&scoped=true", () => {
    console.log('re-render')
    api.rerender('25d14470', render)
  })

}


export default __exports__